import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, Col, Menu, Row, Space } from 'antd';
import { atoms } from 'atoms';
import { CustomButton } from 'components';
import { useAtom } from 'jotai';
import { useAtomValue, useUpdateAtom } from 'jotai/utils';
import { FC, ReactNode } from 'react';
import { useHistory } from 'react-router';
import { SelectYear } from './SelectYear';
import styles from './styles.module.scss';

type TabletHeaderProps = {
  icon?: IconProp;
  title?: string;
  menuItems: ReactNode;
};

export const TabletHeader: FC<TabletHeaderProps> = ({ menuItems }) => {
  const keycloak = useAtomValue(atoms.auth.keycloakInstance);
  const [impersonatedRelation, setImpersonatedRelation] = useAtom(
    atoms.impersonatedRelation,
  );
  const setUser = useUpdateAtom(atoms.user);

  const signOut = () => {
    keycloak.logout();
    setImpersonatedRelation(null);
    setUser(null);
  };
  const history = useHistory();

  const stopImpersonation = () => {
    setImpersonatedRelation(null);
    history.push('/');
  };

  return (
    <div>
      <div style={{ height: 120 }} />
      <div className={styles.header}>
        <Row
          justify="space-between"
          align="middle"
          gutter={20}
          className={styles.row}
          style={{ marginTop: '8px' }}
        >
          <Col span={12}>
            <Row align="middle" gutter={20}>
              <Col
                className={styles.title}
                onClick={() => {
                  const searchParams = new URLSearchParams(
                    window.location.search,
                  );
                  history.push({
                    pathname: '/',
                    search: '?' + searchParams.toString(),
                  });
                }}
              >
                <Avatar size={32} src="logo.svg" /> Digitale
                Graslandgebruikskalender
              </Col>
            </Row>
          </Col>
          <Col span={12} className={styles.textRight}>
            {!impersonatedRelation ? (
              <Space direction="horizontal" size="middle">
                Jaar:
                <SelectYear />
                <CustomButton
                  color="secondary"
                  type="primary"
                  shape="circle"
                  onClick={() => {
                    const searchParams = new URLSearchParams(
                      window.location.search,
                    );
                    history.push({
                      pathname: '/settings',
                      search: '?' + searchParams.toString(),
                    });
                  }}
                  icon={<FontAwesomeIcon icon="cog" />}
                />
                <CustomButton
                  color="primary"
                  type="primary"
                  shape="circle"
                  onClick={signOut}
                  icon={<FontAwesomeIcon icon="sign-out-alt" />}
                />
              </Space>
            ) : (
              <Space direction="horizontal" size="middle">
                Jaar:
                <SelectYear />
                <CustomButton
                  color="secondary"
                  type="primary"
                  shape="round"
                  onClick={stopImpersonation}
                >
                  Sluit bedrijf
                </CustomButton>
              </Space>
            )}
          </Col>
        </Row>
        <Row
          justify="space-between"
          align="middle"
          gutter={20}
          className={styles.row}
        >
          <Col>
            <Menu mode="horizontal">{menuItems}</Menu>
          </Col>
        </Row>
      </div>
    </div>
  );
};
